import type { AuthUser } from "../modal/auth/types";

const AUTH_USER_STORAGE_KEY = "mosidaAuthUser";

export const getStoredAuthUser = (): AuthUser | null => {
  try {
    const raw = localStorage.getItem(AUTH_USER_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);

    if (!parsed || typeof parsed !== "object" || !parsed.id) {
      return null;
    }

    return {
      id: String(parsed.id),
      email: parsed.email ?? null,
      name: parsed.name ?? null,
      phone_number: parsed.phone_number ?? null,
      accessToken: parsed.accessToken ?? null,
    };
  } catch {
    return null;
  }
};

export const persistAuthUser = (user: AuthUser): void => {
  try {
    localStorage.setItem(AUTH_USER_STORAGE_KEY, JSON.stringify(user));
    window.dispatchEvent(new Event("authUserUpdated"));
  } catch {
    // Ignore storage errors (private mode/quota exceeded).
  }
};

export const clearStoredAuthUser = (): void => {
  try {
    localStorage.removeItem(AUTH_USER_STORAGE_KEY);
    window.dispatchEvent(new Event("authUserUpdated"));
  } catch {
    // Ignore storage errors.
  }
};

/** Use access token from login response or persisted auth session. */
export function resolveAuthAccessToken(user?: AuthUser | null): string | null {
  const fromUser = user?.accessToken?.trim();
  if (fromUser) return fromUser;

  const stored = getStoredAuthUser();
  const fromStored = stored?.accessToken?.trim();
  return fromStored || null;
}
